<template>
    <div class="flex justify-start items-center gap-x-1 -mt-2 mb-[15px]">
        <router-link to="/" class="flex rounded-md cursor-pointer">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                :
            </p>
        </router-link>
        <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center">/</p>
        <router-link v-if="text1" :to="link1" class="flex">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                {{ text1 }}
            </p>
        </router-link>
        <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center">/</p>
        <router-link v-if="text2" :to="link2" class="flex">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                {{ text2 }}
            </p>
        </router-link>
        <router-link v-if="text3" :to="link3" class="flex">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                {{ text3 }}
            </p>
        </router-link>
        <router-link v-if="text4" :to="link4" class="flex">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                {{ text4 }}
            </p>
        </router-link>
        <router-link v-if="text5" :to="link5" class="flex">
            <p class="text-[15px] text-sm text-[#302E81] font-medium w-auto whitespace-wrap self-center cursor-pointer hover:underline">
                {{ text5 }}
            </p>
        </router-link>
    </div>
</template>

<script>

export default {
	name: "lucide-icon",
	props:{
        text1: {
            type: String,
        },
        link1: {
            type: String,
        },
        text2: {
            type: String,
        },
        link2: {
            type: String,
        },
        text3: {
            type: String,
        },
        link3: {
            type: String,
        },
        text4: {
            type: String,
        },
        link4: {
            type: String,
        },
        text5: {
            type: String,
        },
        link5: {
            type: String,
        },
    },
    components:{
	},
	data() {
		return {
        }
	},
	created(){
	},
	methods: {
	},
	computed: {
	},
	watch: {
	}
}
</script>./Breadcrumbs.vue